import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { ALL_SELECT_OPTION } from "../../constants";
import { clone } from "../../utils";
import { FormControl, InputLabel, MenuItem, FormControlLabel, Switch } from "@mui/material";
import {
    getDepartmentsByCompany,
    getEmployeesByDepartment,
    getFilters,
    getFiltersInstance,
    getCompaniesWithEvaluations,
} from "../../redux/humanResources/humanResourcesActions";
import { updateFilters } from "../../redux/humanResources/humanResourcesEditionActions";
import { getCompanies } from "../../redux/companies/companiesActions";
import CustomizedSelect from "../Input/CustomizedSelect";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";

class FormsFilters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filtersInstance: getFiltersInstance(
                this.props.myFormsTab,
                this.props.formsToManageTab,
                this.props.humanResourcesTab
            ),
            filtersOpen: false,
        };
    }

    componentDidMount() {
        let formsFilters = this.props.formsFilters[this.state.filtersInstance];

        if (this.props.humanResourcesTab) {
            this.props.getCompaniesWithEvaluations(this.props.activeUser);
            if (!this.props.companies || this.props.companies.length <= 0) {
                this.props.getCompanies(this.props.activeUser, (companies) => {
                    if (!companies || companies.length <= 0) return;

                    let newFilters = clone(formsFilters);
                    newFilters.companies = [ALL_SELECT_OPTION];
                    this.props.updateFilters(newFilters, this.props.activeUser, false);
                    this.props.getFilters(this.props.activeUser, newFilters);
                });
            } else {
                this.props.updateFilters(formsFilters, this.props.activeUser, true);
            }
        } else {
            this.props.getFilters(this.props.activeUser, null);
        }
    }

    inProgressOnlyChange(e, value) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.inProgressOnly = !value;

        if (newFilters.inProgressOnly) newFilters.displayAllDetails = false;

        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    displayAllDetailsChange(e, value) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.displayAllDetails = value;
        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    resetFilter() {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.manager = ALL_SELECT_OPTION;
        newFilters.level = ALL_SELECT_OPTION;
        newFilters.employee = ALL_SELECT_OPTION;
        newFilters.companies = [ALL_SELECT_OPTION];
        newFilters.departments = [];
        newFilters.survey = ALL_SELECT_OPTION;
        newFilters.period = ALL_SELECT_OPTION;
        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    onManagerChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.manager = e.target.value;
        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    onEmployeeChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.employee = e.target.value;
        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    onCompanyChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        let value = e.target.value;
        if (value[value.length - 1] === "ALL") {
            newFilters.companies = ["ALL"];
        } else {
            newFilters.companies = value;
            if (value[0] === "ALL") {
                newFilters.companies.splice(0, 1);
            }
        }
        this.props.getDepartmentsByCompany(newFilters.companies, this.props.activeUser, (departments) => {
            if (departments && departments.length > 0) {
                this.setSelectedDepartment([departments[0].id], newFilters, true);
            } else {
                this.setSelectedDepartment([], newFilters, false);
            }
        });
    }

    onDepartmentChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        this.setSelectedDepartment(e.target.value, newFilters, true);
    }

    setSelectedDepartment(value, newFilters, withRefreshDatas) {
        newFilters.departments = value;

        this.props.updateFilters(newFilters, this.props.activeUser, withRefreshDatas);
        this.props.getEmployeesByDepartment(newFilters.departments, newFilters.companies, this.props.activeUser);
        this.props.getFilters(this.props.activeUser, newFilters, "HUMANRESOURCESTAB");
    }

    onTypeChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.survey = e.target.value;
        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    onPeriodChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.period = e.target.value;
        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    onLevelChange(e) {
        let newFilters = clone(this.props.formsFilters[this.state.filtersInstance]);
        newFilters.level = e.target.value;

        var selectedEmployee = this.props.employeesToManage.find((e) => e.id === newFilters.employee);
        if (
            (newFilters.level === 1 &&
                (!selectedEmployee ||
                    (selectedEmployee && selectedEmployee.parent_id[0] !== this.props.activeUser.emp_id))) ||
            (newFilters.level === 2 &&
                (!selectedEmployee ||
                    (selectedEmployee && selectedEmployee.parent_id[0] === this.props.activeUser.emp_id)))
        ) {
            newFilters.employee = ALL_SELECT_OPTION;
        }

        this.props.updateFilters(newFilters, this.props.activeUser, true);
    }

    handleFiltersClick() {
        this.setState({
            filtersOpen: !this.state.filtersOpen,
        });
    }

    toggleArrow = () => {
        return this.state.open ? (
            <i className="material-icons">keyboard_arrow_up</i>
        ) : (
            <i className="material-icons">keyboard_arrow_down</i>
        );
    };

    render() {
        let formsFilters = this.props.formsFilters[this.state.filtersInstance];

        let allElement = (
            <MenuItem key={0} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        );

        let allFemaleElement = (
            <MenuItem key={0} value={ALL_SELECT_OPTION}>
                {"Toutes"}
            </MenuItem>
        );

        let managerElements = [allElement];
        let employeeElements = [allElement];
        let levelElements = [allElement];
        let companiesElements = [allElement];
        let departmentsElements = [];
        let surveyElements = [allElement];
        let periodElements = [allFemaleElement];
        let distinctEmployees = this.props.formsToManageTab
            ? this.props.employeesToManage
            : this.props.employeesOfCompany;
        let distinctManagers = [];

        this.props.interviews.forEach((i) => {
            if (distinctManagers.filter((e) => e.id === i.user.id).length <= 0) distinctManagers.push(i.user);
        });

        this.props.formSurveys[this.state.filtersInstance]?.map((survey, index) =>
            surveyElements.push(
                <MenuItem key={"survey-" + index} value={survey.id}>
                    {survey.title}
                </MenuItem>
            )
        );

        this.props.periods[this.state.filtersInstance]?.map((period, index) =>
            periodElements.push(
                <MenuItem key={"periods-" + index} value={period.id}>
                    {period.name}
                </MenuItem>
            )
        );

        if (this.props.humanResourcesTab && this.props.companiesWithEvaluations) {
            let test = this.props.companies.filter(
                (c) => c.is_agency && this.props.companiesWithEvaluations.includes(c.id)
            );
            this.props.companies
                .filter((c) => c.is_agency && this.props.companiesWithEvaluations.includes(c.id))
                .map((company, index) =>
                    companiesElements.push(
                        <MenuItem key={"companies-" + index} value={company.id}>
                            {company.name}
                        </MenuItem>
                    )
                );
        }

        this.props.departments.map((department, index) =>
            departmentsElements.push(
                <MenuItem key={"departments-" + index} value={department.id}>
                    {department.name}
                </MenuItem>
            )
        );

        distinctEmployees.map((employee, index) => {
            if (
                (formsFilters.level === 1 && employee.parent_id[0] === this.props.activeUser.emp_id) ||
                (formsFilters.level === 2 && employee.parent_id[0] !== this.props.activeUser.emp_id) ||
                (formsFilters.level !== 1 && formsFilters.level !== 2 && this.props.formsToManageTab) ||
                this.props.humanResourcesTab
            ) {
                employeeElements.push(
                    <MenuItem key={"employee-" + index} value={employee.id}>
                        {employee.name}
                    </MenuItem>
                );
            }
        });

        if (this.props.formsToManageTab) {
            var nMinus1 = this.props.employeesToManage.filter(
                (e) => e.parent_id[0] === this.props.activeUser.emp_id
            ).length;
            var nMinus2 = this.props.employeesToManage.filter(
                (e) => e.parent_id[0] !== this.props.activeUser.emp_id
            ).length;

            if (nMinus1 > 0 && nMinus2 > 0) {
                levelElements.push(
                    <MenuItem key={"level-1"} value={1}>
                        {"N-1"}
                    </MenuItem>
                );
                levelElements.push(
                    <MenuItem key={"level-2"} value={2}>
                        {"N-2"}
                    </MenuItem>
                );
            }
        }

        this.props.managers[this.state.filtersInstance]?.map((manager, index) =>
            managerElements.push(
                <MenuItem key={"managers-" + index} value={manager.id}>
                    {manager.name}
                </MenuItem>
            )
        );

        let activeFilter = 0;
        for (var key in formsFilters) {
            if (
                key !== "inProgressOnly" &&
                key !== "displayAllDetails" &&
                formsFilters[key] &&
                formsFilters[key] !== "ALL"
            ) {
                if (key === "companies") {
                    if (!formsFilters[key].includes("ALL")) {
                        activeFilter++;
                    }
                } else if (key === "departments") {
                    if (departmentsElements.length > 0 && !formsFilters.companies.includes("ALL")) {
                        activeFilter++;
                    }
                } else if (key === "level") {
                    if (this.props.formsToManageTab && formsFilters[key] !== "ALL" && levelElements.length > 1) {
                        activeFilter++;
                    }
                } else {
                    activeFilter++;
                }
            }
        }

        return (
            <Card className={"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card"}>
                <CardContent
                    className={"col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding"}
                    sx={{ paddingBottom: "0 !important", paddingTop: 0 }}
                >
                    <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                        <div
                            className="col-lg-3 col-md-12 col-sm-12 col-12 control-margin-top text-center"
                            style={{ paddingBottom: 0 }}
                        >
                            <div style={{ display: "inline-block" }}>
                                <Badge color="secondary" badgeContent={activeFilter}>
                                    <Button
                                        color="primary"
                                        onClick={this.handleFiltersClick.bind(this)}
                                        variant="contained"
                                        style={{ marginBottom: "10px" }}
                                    >
                                        <i className="material-icons">
                                            <span>filter_list</span>
                                        </i>
                                        <span>Filtres</span>
                                        {this.toggleArrow()}
                                    </Button>
                                </Badge>
                                <Button
                                    color="primary"
                                    onClick={this.resetFilter.bind(this)}
                                    variant="contained"
                                    style={{ marginBottom: "10px", marginLeft: "15px" }}
                                >
                                    Réinitialiser
                                </Button>
                            </div>
                        </div>
                        {this.state.filtersOpen ? (
                            <div className="row sub-header">
                                {this.props.myFormsTab ? (
                                    <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                        <InputLabel id="manager">{"Evaluateur"}</InputLabel>
                                        <CustomizedSelect
                                            label="Evaluateur"
                                            id="manager"
                                            name="manager"
                                            value={formsFilters.manager}
                                            className="full_size select-light-background"
                                            onChange={this.onManagerChange.bind(this)}
                                        >
                                            {managerElements}
                                        </CustomizedSelect>
                                    </FormControl>
                                ) : this.props.formsToManageTab ? (
                                    <>
                                        {levelElements.length > 1 ? (
                                            <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                                <InputLabel id="level">{"Niveau hiérarchique"}</InputLabel>
                                                <CustomizedSelect
                                                    label="Niveau hiérarchique"
                                                    id="level"
                                                    name="level"
                                                    className="full_size select-light-background"
                                                    value={formsFilters.level}
                                                    onChange={this.onLevelChange.bind(this)}
                                                >
                                                    {levelElements}
                                                </CustomizedSelect>
                                            </FormControl>
                                        ) : null}
                                        <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                            <InputLabel id="employee">{"Collaborateur"}</InputLabel>
                                            <CustomizedSelect
                                                label="Collaborateur"
                                                id="employee"
                                                name="employee"
                                                className="full_size select-light-background"
                                                value={formsFilters.employee}
                                                onChange={this.onEmployeeChange.bind(this)}
                                            >
                                                {employeeElements}
                                            </CustomizedSelect>
                                        </FormControl>
                                    </>
                                ) : (
                                    <>
                                        <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                            <InputLabel id="company">{"Agence"}</InputLabel>
                                            <CustomizedSelect
                                                id="company"
                                                name="company"
                                                label="Agence"
                                                value={formsFilters.companies}
                                                className="full_size select-light-background"
                                                onChange={this.onCompanyChange.bind(this)}
                                                multiple
                                            >
                                                {companiesElements}
                                            </CustomizedSelect>
                                        </FormControl>
                                        {departmentsElements.length > 0 && !formsFilters.companies.includes("ALL") ? (
                                            <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                                <InputLabel id="department">{"Département"}</InputLabel>
                                                <CustomizedSelect
                                                    id="department"
                                                    name="department"
                                                    label="Département"
                                                    className="full_size select-light-background"
                                                    value={formsFilters.departments}
                                                    onChange={this.onDepartmentChange.bind(this)}
                                                    multiple
                                                >
                                                    {departmentsElements}
                                                </CustomizedSelect>
                                            </FormControl>
                                        ) : null}
                                        <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                            <InputLabel id="employee">{"Collaborateur"}</InputLabel>
                                            <CustomizedSelect
                                                label="Collaborateur"
                                                id="employee"
                                                name="employee"
                                                className="full_size select-light-background"
                                                value={formsFilters.employee}
                                                onChange={this.onEmployeeChange.bind(this)}
                                            >
                                                {employeeElements}
                                            </CustomizedSelect>
                                        </FormControl>
                                    </>
                                )}
                                <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                    <InputLabel id="survey">{"Type"}</InputLabel>
                                    <CustomizedSelect
                                        label="Type"
                                        id="survey"
                                        name="survey"
                                        className="full_size select-light-background"
                                        value={formsFilters.survey}
                                        onChange={this.onTypeChange.bind(this)}
                                    >
                                        {surveyElements}
                                    </CustomizedSelect>
                                </FormControl>
                                <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                    <InputLabel id="type">{"Périodes"}</InputLabel>
                                    <CustomizedSelect
                                        label="Périodes"
                                        id="period"
                                        name="period"
                                        className="full_size select-light-background"
                                        value={formsFilters.period}
                                        onChange={this.onPeriodChange.bind(this)}
                                    >
                                        {periodElements}
                                    </CustomizedSelect>
                                </FormControl>
                            </div>
                        ) : null}
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <FormControlLabel
                                className={"element-right control-margin-top span-center-verticaly"}
                                sx={{ marginBottom: "10px" }}
                                control={
                                    <Switch
                                        value={"valide"}
                                        color="secondary"
                                        onChange={this.inProgressOnlyChange.bind(this)}
                                        checked={!formsFilters.inProgressOnly}
                                    />
                                }
                                label={"Terminés"}
                            ></FormControlLabel>
                        </div>
                        <div className="col-6">
                            {!formsFilters.inProgressOnly ? (
                                <FormControlLabel
                                    className={"control-margin-top span-center-verticaly"}
                                    sx={{ marginBottom: "10px" }}
                                    control={
                                        <Switch
                                            value={"valide"}
                                            color="secondary"
                                            onChange={this.displayAllDetailsChange.bind(this)}
                                            checked={formsFilters.displayAllDetails}
                                        />
                                    }
                                    label={"Détails"}
                                ></FormControlLabel>
                            ) : null}
                        </div>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        formsFilters: state.forms.formsFilters,
        formSurveys: state.forms.formSurveys,
        employeesToManage: state.forms.employeesToManage,
        employeesOfCompany: state.forms.employeesOfCompany,
        periods: state.forms.periods,
        managers: state.forms.managers,
        companies: state.companies.companies,
        departments: state.forms.departmentsOfCompany,
        interviews: state.forms.interviewsToManage,
        companiesWithEvaluations: state.forms.companiesWithEvaluations,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateFilters: (filters, user, withRefreshDatas) =>
            dispatch(
                updateFilters(
                    filters,
                    withRefreshDatas,
                    ownProps.myFormsTab,
                    ownProps.formsToManageTab,
                    ownProps.humanResourcesTab,
                    user
                )
            ),
        getFilters: (user, filters, callingFrom) =>
            dispatch(
                getFilters(
                    user,
                    filters,
                    ownProps.myFormsTab,
                    ownProps.formsToManageTab,
                    ownProps.humanResourcesTab,
                    callingFrom
                )
            ),
        getCompanies: (user, onSuccess) => dispatch(getCompanies(user, onSuccess)),
        getDepartmentsByCompany: (companyIds, user, onSuccess) =>
            dispatch(getDepartmentsByCompany(companyIds, user, onSuccess)),
        getEmployeesByDepartment: (departmentIds, companyIds, user) =>
            dispatch(getEmployeesByDepartment(departmentIds, companyIds, user)),
        getCompaniesWithEvaluations: (user) => dispatch(getCompaniesWithEvaluations(user)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormsFilters);
